module.exports = __webpack_public_path__ + "img/img1_3.8bcf9ed5.jpeg";